var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchoolDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9075 15.9968V18.8068C7.9075 19.5368 8.3075 20.2168 8.9475 20.5668L13.9475 23.2968C14.5475 23.6268 15.2675 23.6268 15.8675 23.2968L20.8675 20.5668C21.5075 20.2168 21.9075 19.5368 21.9075 18.8068V15.9968L15.8675 19.2968C15.2675 19.6268 14.5475 19.6268 13.9475 19.2968L7.9075 15.9968ZM13.9475 6.3368L5.5175 10.9368C4.8275 11.3168 4.8275 12.3168 5.5175 12.6968L13.9475 17.2968C14.5475 17.6268 15.2675 17.6268 15.8675 17.2968L23.9075 12.9068V18.8168C23.9075 19.3668 24.3575 19.8168 24.9075 19.8168C25.4575 19.8168 25.9075 19.3668 25.9075 18.8168V12.4068C25.9075 12.0368 25.7075 11.7068 25.3875 11.5268L15.8675 6.3368C15.2675 6.0168 14.5475 6.0168 13.9475 6.3368Z",
    fill: "#8C99B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolDark);
export default __webpack_public_path__ + "static/media/school_dark.e6abf021c87ae511ea07ad5568c714b9.svg";
export { ForwardRef as ReactComponent };